import type React from 'react';

import { useCannedResponsesActions } from '../../../../hooks/chat/useCannedResponsesActions';
import { CannedResponseDataModal } from './CannedResponseDataModal';

export const CreateCannedResponseModal: React.FC = () => {
  const { createCannedResponse } = useCannedResponsesActions();

  return <CannedResponseDataModal onSubmit={createCannedResponse} />;
};

export default CreateCannedResponseModal;
